import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';

import {
    Box, Typography, Card, CardHeader, CardContent, CardMedia, Avatar, Button, Select, MenuItem, InputLabel, FormControl,
    TextField, FormControlLabel, Checkbox, Autocomplete
} from "@mui/material";
import { useSnackbar } from 'notistack';
import Grid from '@mui/material/Grid2';
import {
    Article, Search, ListAlt, Description, MenuBook, FormatListBulleted, CloudUpload, PersonAdd
} from "@mui/icons-material";

import ArticleServices from '../services/ArticleServices';
import DepartmentServices from '../services/DepartmentServices';
import ClassServices from '../services/ClassServices';
import ExamSessionServices from '../services/ExamSessionServices';

import logo from '~/assets/images/loGo.png';
import bg from '~/assets/images/hero-bg.png';
import nhi from '~/assets/images/nhi.png'
import hanh from '~/assets/images/hanh.png'
import ly from '~/assets/images/ly.png'
import duy from '~/assets/images/duy.png'
import nghia from '~/assets/images/nghia.png'
import StudentServices from '../services/StudentServices';

const supportFeature = [
    {
        title: "Kế hoạch thi năm 2025",
        content: "Thông tin về các kỳ thi như: Lịch thi, hình thức thi, ngày đăng ký, thời gian có kết quả, ngày nhận chứng chỉ.",
        icon: <Article sx={{ fontSize: 50 }} />,
        url: "/exam-plan",
        target: "_self"
    },
    {
        title: "Tra cứu kết quả thi",
        content: "Tra cứu kết quả thi đánh giá năng lực trực tuyến, xem thông tin lịch sử kết quả thi, tra cứu kết quả phúc khảo.",
        icon: <Search sx={{ fontSize: 50 }} />,
        url: "https://nnth.dthu.edu.vn/Thongtin_Tonghop.aspx",
        target: "_blank"
    },
    {
        title: "Qui trình",
        content: "Mô tả các bước để đăng ký dự thi, nhận giấy chứng nhận tạm thời và chứng chỉ, nộp phiếu đề nghị chấm phúc khảo.",
        icon: <ListAlt sx={{ fontSize: 50 }} />,
        url: "/exam-procedure",
        target: "_self"
    },
    {
        title: "Biểu mẫu",
        content: "Đề nghị nhận giấy chứng nhận tạm thời, chấm phúc khảo, điều chỉnh thông tin, ủy quyền nhận chứng chỉ, đăng ký nhận qua bưu điện.",
        icon: <Description sx={{ fontSize: 50 }} />,
        url: "/form-template",
        target: "_self"
    },
    {
        title: "Tài liệu tham khảo",
        content: "Download các tài liệu tham khảo liên quan đến kỳ thi như Đề thi minh họa...",
        icon: <MenuBook sx={{ fontSize: 50 }} />,
        url: "/refer-document",
        target: "_self"
    },
    {
        title: "Định dạng đề thi",
        content: "Định dạng Đề thi đánh giá năng lực sử dụng Tin học cơ bản cho Việt Nam",
        icon: <FormatListBulleted sx={{ fontSize: 50 }} />,
        url: "/refer-document",
        target: "_self"
    }
];

const teacherSupport = [
    {
        name: "Phạm Mai Duy",
        majors: "Kế toán",
        content: "Hỗ trợ thu học phí, lệ phí thi cho thí sinh, đăng ký dự thi, in phiếu đăng ký dự thi.",
        avatar: duy
    },
    {
        name: "Trần Thị Yến Nhi",
        majors: "Ngoại ngữ",
        content: "Hỗ trợ đăng ký thi, in phiếu đăng ký dự thi, in thẻ dự thi, cập nhật thông tin thí sinh.",
        avatar: nhi
    },
    {
        name: "Cao Thị Thanh Nghĩa",
        majors: "Ngoại ngữ",
        content: "Hỗ trợ đăng ký thi, in phiếu đăng ký dự thi, in thẻ dự thi, cập nhật thông tin thí sinh.",
        avatar: nghia
    },
    {
        name: "Huỳnh Hồng Hạnh",
        majors: "Tin học",
        content: "Hỗ trợ đăng ký thi, in phiếu đăng ký dự thi, in thẻ dự thi, cập nhật thông tin thí sinh.",
        avatar: hanh
    },
    {
        name: "Vũ Thị Lý",
        majors: "Kế Toán",
        content: "Hỗ trợ thu học phí, lệ phí thi cho thí sinh, đăng ký dự thi, in phiếu đăng ký dự thi.",
        avatar: ly
    },
]

const provinces = [
    "Hà Nội", "Hồ Chí Minh", "Đà Nẵng", "Hải Phòng", "Cần Thơ",
    "An Giang", "Bà Rịa - Vũng Tàu", "Bắc Giang", "Bắc Kạn", "Bạc Liêu",
    "Bắc Ninh", "Bến Tre", "Bình Định", "Bình Dương", "Bình Phước",
    "Bình Thuận", "Cà Mau", "Cao Bằng", "Đắk Lắk", "Đắk Nông",
    "Điện Biên", "Đồng Nai", "Đồng Tháp", "Gia Lai", "Hà Giang",
    "Hà Nam", "Hà Tĩnh", "Hải Dương", "Hậu Giang", "Hòa Bình",
    "Hưng Yên", "Khánh Hòa", "Kiên Giang", "Kon Tum", "Lai Châu",
    "Lâm Đồng", "Lạng Sơn", "Lào Cai", "Long An", "Nam Định",
    "Nghệ An", "Ninh Bình", "Ninh Thuận", "Phú Thọ", "Phú Yên",
    "Quảng Bình", "Quảng Nam", "Quảng Ngãi", "Quảng Ninh", "Quảng Trị",
    "Sóc Trăng", "Sơn La", "Tây Ninh", "Thái Bình", "Thái Nguyên",
    "Thanh Hóa", "Thừa Thiên Huế", "Tiền Giang", "Trà Vinh", "Tuyên Quang",
    "Vĩnh Long", "Vĩnh Phúc", "Yên Bái"
];
function formatDate(dateInput, formatType = 'dd/mm/yyyy') {
    if (!dateInput) return "";

    const date = new Date(dateInput);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    if (formatType === 'yyyy-mm-dd') {
        return `${year}-${month}-${day}`;
    } else if (formatType === 'dd/mm/yyyy') {
        return `${day}/${month}/${year}`;
    } else {
        throw new Error("formatType must be 'dd/mm/yyyy' or 'yyyy-mm-dd'");
    }
}

const subject = ["Thực hành", "Lý thuyết"];

const Home = () => {
    const [listArticle, setListArticle] = useState([]);
    const [listDepartment, setListDepartment] = useState([]);
    const [listClass, setListClass] = useState([]);
    const [examNew, setExamNew] = useState({});
    const [isDthu, setIsDthu] = useState(false);
    const [isDeferred, setIsDeferred] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    const [inforStudentRegis, setInforStudentRegis] = useState({
        name: "", studentCode: "", identNumber: "", dateIssue: "", placeIssue: "", placeBirth: "", birthday: "",
        sex: "", nation: "", itClass: "", email: "", contestants: "", phone: "", classID: "", departmentID: "",
        level: "Ứng dụng Công nghệ thông tin cơ bản", prevExamDay: "", deferredSubject: "", resitSubject: "",
        avatarFile: "", avatar: "", imageBankingFile: "", imageBanking: "", examSessionID: 3, statusRegisID: 2
    })

    const [heplText, setHeplText] = useState({
        errorName: "", errorIdentNumber: "", errorDateIssue: "", errorPlaceIssue: "", errorPlaceBirth: "",
        errorBirthday: "", errorSex: "", errorNation: "", errorItClass: "", errorEmail: "", errorContestants: "",
        errorPhone: "", errorClassID: "", errorDepartmentID: "", errorPrevExamDay: "", errorDeferredSubject: "",
        errorResitSubject: "", errorAvatarFile: "", errorImageBankingFile: "", errorStudentCode: ""
    })

    const showAlert = useCallback((message, variant) => {
        enqueueSnackbar(message, { variant });
    }, [enqueueSnackbar]);

    const getArticle = useCallback(async () => {
        try {
            let response = await ArticleServices.getByCategory("", "Thông báo thi", true, 3, 1);
            if (response) {
                setListArticle(response.items);
            }
        } catch (error) {
            showAlert("Lỗi khi tải thông báo!", "error");
            console.error(error);
        }
    }, [showAlert]);

    const getDepartment = useCallback(async () => {
        try {
            let response = await DepartmentServices.getAll();
            if (response) {
                setListDepartment(response.items);
            }
        } catch (error) {
            showAlert("Lỗi khi tải danh sách khoa!", "error");
            console.error(error);
        }
    }, [showAlert]);

    const getExamNew = useCallback(async () => {
        try {
            let response = await ExamSessionServices.getNewExam();
            if (response) {
                setExamNew(response);
            }
        } catch (error) {
            showAlert("Lỗi khi tải kỳ thi mới!", "error");
            console.error(error);
        }
    }, [showAlert]);

    const getClass = async (id) => {
        try {
            let response = await ClassServices.getByDepartmentId(id);
            if (response) {
                setListClass(response);
            }
        } catch (error) {
            showAlert("Lỗi khi tải danh sách lớp!", "error");
            console.error(error);
        }
    };

    useEffect(() => {
        getArticle();
        getDepartment();
        getExamNew();
    }, [getArticle, getDepartment, getExamNew]);

    const handleChangeInfo = (e) => {
        const { name, value } = e.target;
        if (name !== "avatarFile" && name !== "imageBankingFile") {
            setInforStudentRegis((prev) => ({ ...prev, [name]: value }));
            return;
        }

        if (name === "avatarFile" && e.target.files[0] instanceof File && e.target.files?.length > 0) {
            if (inforStudentRegis.avatar) {
                URL.revokeObjectURL(inforStudentRegis.avatar);
            }
            setInforStudentRegis((prev) => ({
                ...prev,
                [name]: e.target.files[0],
                avatar: URL.createObjectURL(e.target.files[0]),
            }));
            e.target.value = "";
            return;
        }

        if (name === "imageBankingFile" && e.target.files[0] instanceof File && e.target.files?.length > 0) {
            if (inforStudentRegis.imageBanking) {
                URL.revokeObjectURL(inforStudentRegis.imageBanking);
            }
            setInforStudentRegis((prev) => ({
                ...prev,
                [name]: e.target.files[0],
                imageBanking: URL.createObjectURL(e.target.files[0]),
            }));
            e.target.value = "";
            return;
        }
    };

    const handleUploadImage = async (fileIamge) => {
        try {
            if (fileIamge instanceof File) {
                let imagePath = await StudentServices.uploadImage(fileIamge);
                return imagePath;
            }
            return null;
        } catch (error) {
            console.log(error);
        }
    }

    const handleUploadImageBanking = async (fileIamge) => {
        try {
            if (fileIamge instanceof File) {
                let imagePath = await StudentServices.uploadImageBanking(fileIamge);
                return imagePath;
            }
            return null;
        } catch (error) {
            console.log(error);
        }
    }

    const handleCheckError = () => {
        let isError = false;
        let errorCheck = { ...heplText };
        const today = new Date().toISOString().split("T")[0]; // Lấy ngày hiện tại (YYYY-MM-DD)
        const phoneRegex = /^[0-9]{10}$/; // SĐT phải có 10 số
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Định dạng email

        // Họ và tên
        if (!inforStudentRegis.name.trim()) {
            isError = true;
            errorCheck.errorName = "Vui lòng nhập họ và tên";
        } else {
            errorCheck.errorName = "";
        }

        // CCCD
        if (!inforStudentRegis.identNumber.trim()) {
            isError = true;
            errorCheck.errorIdentNumber = "Vui lòng nhập số CCCD";
        } else if (inforStudentRegis.identNumber.trim().length !== 12) {
            isError = true;
            errorCheck.errorIdentNumber = "CCCD phải có đúng 12 số";
        } else if (isNaN(inforStudentRegis.identNumber.trim())) {
            isError = true;
            errorCheck.errorIdentNumber = "CCCD chỉ được chứa số";
        } else {
            errorCheck.errorIdentNumber = "";
        }

        // Ngày cấp CCCD
        if (!inforStudentRegis.dateIssue) {
            isError = true;
            errorCheck.errorDateIssue = "Vui lòng nhập ngày cấp";
        } else if (inforStudentRegis.dateIssue > today) {
            isError = true;
            errorCheck.errorDateIssue = "Ngày cấp không được lớn hơn ngày hiện tại";
        } else {
            errorCheck.errorDateIssue = "";
        }

        // Nơi cấp CCCD
        if (!inforStudentRegis.placeIssue) {
            isError = true;
            errorCheck.errorPlaceIssue = "Vui lòng nhập nơi cấp CCCD";
        } else {
            errorCheck.errorPlaceIssue = "";
        }

        // Ngày sinh
        if (!inforStudentRegis.birthday) {
            isError = true;
            errorCheck.errorBirthday = "Vui lòng nhập ngày sinh";
        } else if (inforStudentRegis.birthday > today) {
            isError = true;
            errorCheck.errorBirthday = "Ngày sinh không được lớn hơn ngày hiện tại";
        } else {
            errorCheck.errorBirthday = "";
        }

        // Nơi sinh
        if (!inforStudentRegis.placeBirth.trim()) {
            isError = true;
            errorCheck.errorPlaceBirth = "Vui lòng nhập nơi sinh";
        } else {
            errorCheck.errorPlaceBirth = "";
        }

        // Giới tính
        if (!inforStudentRegis.sex) {
            isError = true;
            errorCheck.errorSex = "Vui lòng chọn giới tính";
        } else {
            errorCheck.errorSex = "";
        }

        // Dân tộc
        if (!inforStudentRegis.nation.trim()) {
            isError = true;
            errorCheck.errorNation = "Vui lòng nhập dân tộc";
        } else {
            errorCheck.errorNation = "";
        }


        // Email
        if (!inforStudentRegis.email.trim()) {
            isError = true;
            errorCheck.errorEmail = "Vui lòng nhập email";
        } else if (!emailRegex.test(inforStudentRegis.email.trim())) {
            isError = true;
            errorCheck.errorEmail = "Email không hợp lệ";
        } else {
            errorCheck.errorEmail = "";
        }

        // Số điện thoại
        if (!inforStudentRegis.phone.trim()) {
            isError = true;
            errorCheck.errorPhone = "Vui lòng nhập số điện thoại";
        } else if (!phoneRegex.test(inforStudentRegis.phone.trim())) {
            isError = true;
            errorCheck.errorPhone = "Số điện thoại phải có đúng 10 số";
        } else {
            errorCheck.errorPhone = "";
        }

        // Đối tượng dự thi
        if (!inforStudentRegis.contestants) {
            isError = true;
            errorCheck.errorContestants = "Vui lòng nhập đối tượng dự thi";
        } else {
            errorCheck.errorContestants = "";
        }

        if (isDthu) {
            if (!inforStudentRegis.studentCode.trim()) {
                isError = true;
                errorCheck.errorStudentCode = "Vui lòng nhập mã số sinh viên";
            } else {
                errorCheck.errorStudentCode = "";
            }
            if (!inforStudentRegis.departmentID) {
                isError = true;
                errorCheck.errorDepartmentID = "Vui lòng chọn Khoa";
            } else {
                errorCheck.errorDepartmentID = "";
            }

            if (!inforStudentRegis.classID) {
                isError = true;
                errorCheck.errorClassID = "Vui lòng chọn Lớp";
            } else {
                errorCheck.errorClassID = "";
            }
        }
        if (isDeferred) {
            // Ngày thi trước đó
            if (!inforStudentRegis.prevExamDay) {
                isError = true;
                errorCheck.errorPrevExamDay = "Vui lòng nhập ngày thi trước đó";
            } else if (inforStudentRegis.prevExamDay > today) {
                isError = true;
                errorCheck.errorPrevExamDay = "Ngày thi trước đó không được lớn hơn ngày hiện tại";
            } else {
                errorCheck.errorPrevExamDay = "";
            }

            // Môn bảo lưu
            if (!inforStudentRegis.deferredSubject) {
                isError = true;
                errorCheck.errorDeferredSubject = "Vui lòng nhập môn bảo lưu";
            } else {
                errorCheck.errorDeferredSubject = "";
            }

            // Môn thi lại
            if (!inforStudentRegis.resitSubject) {
                isError = true;
                errorCheck.errorResitSubject = "Vui lòng nhập môn thi lại";
            } else {
                errorCheck.errorResitSubject = "";
            }
        }
        // Ảnh đại diện
        if (!inforStudentRegis.avatarFile) {
            isError = true;
            errorCheck.errorAvatarFile = "Vui lòng tải lên ảnh đại diện";
        } else {
            errorCheck.errorAvatarFile = "";
        }

        // Ảnh chuyển khoản
        if (!inforStudentRegis.imageBankingFile) {
            isError = true;
            errorCheck.errorImageBankingFile = "Vui lòng tải lên ảnh chuyển khoản";
        } else {
            errorCheck.errorImageBankingFile = "";
        }

        // Cập nhật lỗi vào state
        setHeplText(errorCheck);
        return isError;
    };

    function capitalizeEveryWord(str) {
        return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
            .join(' ');
    }
    

    const handleRegis = async () => {
        setIsLoading(true);
        const isValid = handleCheckError();

        if (isValid) {
            showAlert("Thông tin nhập chưa chính xác!", "warning");
            setIsLoading(false);
            return;
        }

        if (isDeferred) {
            let responseCheckDeferred = await StudentServices.checkDeferred(inforStudentRegis.prevExamDay);
            if (responseCheckDeferred && !responseCheckDeferred.isCheck) {
                setHeplText((prev) => ({ ...prev, errorPrevExamDay: "Ngày thi quá 3 tháng không thể bảo lưu" }))
                showAlert("Thông tin nhập chưa chính xác!", "warning");
                setIsLoading(false);

                return;
            }
        }

        try {
            let avatarPath = await handleUploadImage(inforStudentRegis.avatarFile);
            if (!avatarPath) {
                showAlert("Lỗi khi tải ảnh avatar!", "error");
                setIsLoading(false);

                return;
            }
            let imageBankingPath = await handleUploadImageBanking(inforStudentRegis.imageBankingFile);
            if (!imageBankingPath) {
                showAlert("Lỗi khi tải ảnh minh chứng!", "error");
                setIsLoading(false);

                return;
            }

            let data = {
                name: capitalizeEveryWord(inforStudentRegis.name.trim()),
                studentCode: inforStudentRegis.studentCode.trim(),
                identNumber: inforStudentRegis.identNumber.trim(),
                dateIssue: inforStudentRegis.dateIssue,
                placeIssue: inforStudentRegis.placeIssue.trim(),
                placeBirth: inforStudentRegis.placeBirth.trim(),
                birthday: inforStudentRegis.birthday,
                sex: inforStudentRegis.sex,
                nation: capitalizeEveryWord(inforStudentRegis.nation.trim()),
                itClass: inforStudentRegis.itClass.trim(),
                email: inforStudentRegis.email.trim(),
                contestants: inforStudentRegis.contestants,
                phone: inforStudentRegis.phone.trim(),
                classID: inforStudentRegis.classID ? inforStudentRegis.classID : null,
                level: "Ứng dụng Công nghệ thông tin cơ bản",
                prevExamDay: inforStudentRegis.prevExamDay ? inforStudentRegis.prevExamDay : null,
                deferredSubject: inforStudentRegis.deferredSubject ? inforStudentRegis.deferredSubject : null,
                resitSubject: inforStudentRegis.resitSubject ? inforStudentRegis.resitSubject : null,
                avatar: avatarPath,
                imageBanking: imageBankingPath,
                examSessionID: examNew.id,
                statusRegisID: 2
            }
            let response = await StudentServices.studentExamRegis(data);
            if (response && response.success === false) {
                showAlert(response.message, "warning");
                setIsLoading(false);

                return;
            }
            if (response && response.success === true) {
                setInforStudentRegis({
                    name: "", studentCode: "", identNumber: "", dateIssue: "", placeIssue: "", placeBirth: "", birthday: "",
                    sex: "", nation: "", itClass: "", email: "", contestants: "", phone: "", classID: "", departmentID: "",
                    level: "Ứng dụng Công nghệ thông tin cơ bản", prevExamDay: "", deferredSubject: "", resitSubject: "",
                    avatarFile: "", avatar: "", imageBankingFile: "", imageBanking: "", examSessionID: 3, statusRegisID: 2
                });
                setHeplText({
                    errorName: "", errorIdentNumber: "", errorDateIssue: "", errorPlaceIssue: "", errorPlaceBirth: "",
                    errorBirthday: "", errorSex: "", errorNation: "", errorItClass: "", errorEmail: "", errorContestants: "",
                    errorPhone: "", errorClassID: "", errorDepartmentID: "", errorPrevExamDay: "", errorDeferredSubject: "",
                    errorResitSubject: "", errorAvatarFile: "", errorImageBankingFile: "", errorStudentCode: ""
                });
                showAlert("Đăng ký thi thành công!", "success");

            }
            setIsLoading(false);

        } catch (error) {
            showAlert("Lỗi khi đăng ký thi!", "error");
            console.error(error);
        }
    }

    return (
        <>
            <Box sx={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${bg})`,
                backgroundPosition: 'center', backgroundRepeat: "no-repeat", backgroundSize: 'cover',
            }}>
                <Box sx={{ maxWidth: "lg", marginInline: "auto", minHeight: "100vh", p: 2, color: "var(--white)" }}>
                    <Box
                        sx={{
                            backgroundColor: "var(--white)", color: "black", paddingBlock: 4, paddingInline: { md: 4, xs: 2 }, marginBlock: 8,
                            borderRadius: 4, maxWidth: { md: "60%", xs: "90%" }, marginInline: "auto"
                        }}>
                        <Typography variant='h5'
                            sx={{ fontWeight: "bold", textAlign: "center", color: "var(--primary)" }}>
                            ĐĂNG KÝ DỰ THI ỨNG DỤNG CNTT CƠ BẢN
                        </Typography>
                        <Typography sx={{ color: "red", mt: 2, textAlign: { md: "center", xs: "justify" } }}>
                            Lưu ý: Thông tin khai báo sẽ được làm căn cứ cấp chứng chỉ sau này, vì vậy thí sinh vui lòng
                            khai báo thông tin thật chính xác. Đối với thí sinh không phải sinh viên trường, thông tin nào không có thì bỏ trống. {" "}
                            <Link to="/exam-instruction" className='link-blue'
                                style={{ color: "var(--primary)", textDecoration: "none" }}>
                                Xem hướng dẫn đăng ký thi tại đây
                            </Link>
                        </Typography>
                        <Grid container spacing={2} sx={{ mt: 4 }}>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <FormControl fullWidth >
                                    <InputLabel id="contestants">
                                        <span>Đối tượng dự thi <span style={{ color: "red" }}>*</span></span>
                                    </InputLabel>
                                    <Select
                                        labelId="contestants"
                                        label="Đối tượng dự thi *"
                                        name="contestants"
                                        value={inforStudentRegis.contestants}
                                        onChange={handleChangeInfo}
                                    >
                                        <MenuItem value="Học viên">Học viên tại trung tâm</MenuItem>
                                        <MenuItem value="Tự do">Thí sinh tự do</MenuItem>
                                    </Select>
                                    {heplText.errorContestants && (
                                        <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                            {heplText.errorContestants}
                                        </Box>
                                    )}

                                </FormControl>
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth
                                    label={
                                        isDthu
                                            ? <span>Mã số sinh viên <span style={{ color: "red" }}>*</span></span>
                                            : <span>Mã số sinh viên</span>
                                    }
                                    variant="outlined"
                                    name="studentCode"
                                    value={inforStudentRegis.studentCode}
                                    onChange={handleChangeInfo}
                                />
                                {heplText.errorStudentCode && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorStudentCode}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth variant="outlined"
                                    label={
                                        <span>Họ và tên <span style={{ color: "red" }}>*</span></span>
                                    }
                                    name="name"
                                    value={inforStudentRegis.name}
                                    onChange={handleChangeInfo}
                                />
                                {heplText.errorName && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorName}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <FormControl fullWidth >
                                    <InputLabel id="sex">
                                        <span>Giới tính <span style={{ color: "red" }}>*</span></span>
                                    </InputLabel>
                                    <Select
                                        labelId="sex"
                                        label="Giới tính *"
                                        name="sex"
                                        value={inforStudentRegis.sex}
                                        onChange={handleChangeInfo}
                                    >
                                        <MenuItem value="Nam">Nam</MenuItem>
                                        <MenuItem value="Nữ">Nữ</MenuItem>
                                    </Select>
                                    {heplText.errorSex && (
                                        <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                            {heplText.errorSex}
                                        </Box>
                                    )}

                                </FormControl>
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    label={
                                        <span>Ngày sinh <span style={{ color: "red" }}>*</span></span>
                                    }
                                    variant="outlined"
                                    fullWidth
                                    type="date"
                                    name='birthday'
                                    value={inforStudentRegis.birthday || ""}
                                    onChange={handleChangeInfo}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                                {heplText.errorBirthday && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorBirthday}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Autocomplete
                                    options={provinces}
                                    getOptionLabel={(option) => option}
                                    name="placeBirth"
                                    value={inforStudentRegis.placeBirth}
                                    onChange={(e, value) =>
                                        value && handleChangeInfo({ target: { name: "placeBirth", value } })
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params}
                                            label={
                                                <span>Nơi sinh <span style={{ color: "red" }}>*</span></span>
                                            }
                                            variant="outlined" />
                                    )}
                                />
                                {heplText.placeBirth && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.placeBirth}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth variant="outlined"
                                    label={
                                        <span>Căn cước công dân <span style={{ color: "red" }}>*</span></span>
                                    }
                                    name="identNumber"
                                    value={inforStudentRegis.identNumber}
                                    onChange={handleChangeInfo}
                                />
                                {heplText.errorIdentNumber && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorIdentNumber}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    label={
                                        <span>Ngày cấp CCCD <span style={{ color: "red" }}>*</span></span>
                                    }
                                    variant="outlined"
                                    fullWidth
                                    type="date"
                                    name='dateIssue'
                                    value={inforStudentRegis.dateIssue || ""}
                                    onChange={handleChangeInfo}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                                {heplText.errorDateIssue && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorDateIssue}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth variant="outlined"
                                    label={
                                        <span>Nơi cấp CCCD <span style={{ color: "red" }}>*</span></span>
                                    }
                                    name="placeIssue"
                                    value={inforStudentRegis.placeIssue}
                                    onChange={handleChangeInfo}
                                />
                                {heplText.errorPlaceIssue && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorPlaceIssue}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth variant="outlined"
                                    label={
                                        <span>Dân tộc <span style={{ color: "red" }}>*</span></span>
                                    }
                                    name="nation"
                                    value={inforStudentRegis.nation}
                                    onChange={handleChangeInfo}
                                />
                                {heplText.errorNation && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorNation}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth variant="outlined"
                                    label={
                                        <span>Email <span style={{ color: "red" }}>*</span></span>
                                    }
                                    name="email"
                                    value={inforStudentRegis.email}
                                    onChange={handleChangeInfo}
                                />
                                {heplText.errorEmail && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorEmail}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth variant="outlined"
                                    label={
                                        <span>Số điện thoại <span style={{ color: "red" }}>*</span></span>
                                    }
                                    name="phone"
                                    value={inforStudentRegis.phone}
                                    onChange={handleChangeInfo}
                                />
                                {heplText.errorPhone && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorPhone}
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={12}>
                                <FormControlLabel
                                    control={<Checkbox onChange={() => {
                                        setIsDthu(!isDthu);
                                        handleChangeInfo({ target: { name: "departmentID", value: "" } });
                                        handleChangeInfo({ target: { name: "classID", value: "" } });
                                        setHeplText((prev) => ({ ...prev, errorDepartmentID: "", errorClassID: "", errorStudentCode: "" }))
                                    }} />}
                                    label="Sinh viên Đại học Đồng Tháp" />
                            </Grid>
                            {isDthu && (
                                <>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Autocomplete
                                            options={listDepartment}
                                            getOptionLabel={(option) => option.name}
                                            name="departmentID"
                                            onChange={async (event, value) => {
                                                if (value) {
                                                    handleChangeInfo({ target: { name: "departmentID", value: value.id } })
                                                    await getClass(value.id);
                                                } else {
                                                    setListClass([]);
                                                    handleChangeInfo({ target: { name: "classID", value: "" } })
                                                    handleChangeInfo({ target: { name: "departmentID", value: "" } })
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label={
                                                        <span>Khoa <span style={{ color: "red" }}>*</span></span>
                                                    }
                                                    variant="outlined" />
                                            )}
                                        />
                                        {heplText.errorDepartmentID && (
                                            <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                                {heplText.errorDepartmentID}
                                            </Box>
                                        )}
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Autocomplete
                                            options={listClass}
                                            getOptionLabel={(option) => option.name}
                                            name="classID"
                                            value={listClass.find((item) => item.id === inforStudentRegis.classID) || null}
                                            onChange={(e, value) =>
                                                value && handleChangeInfo({ target: { name: "classID", value: value.id } })
                                            }
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label={
                                                        <span>Lớp tại Dthu <span style={{ color: "red" }}>*</span></span>
                                                    }
                                                    variant="outlined" />
                                            )}
                                        />
                                        {heplText.errorClassID && (
                                            <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                                {heplText.errorClassID}
                                            </Box>
                                        )}
                                    </Grid>

                                </>
                            )}

                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth label="Lớp học tại trung tâm" variant="outlined"
                                    name="itClass"
                                    value={inforStudentRegis.itClass}
                                    onChange={handleChangeInfo}
                                />
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth label="Bậc thi" variant="outlined"
                                    slotProps={{ htmlInput: { readOnly: true } }}
                                    value="Ứng dụng Công nghệ thông tin cơ bản"
                                />
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth label="Đợt thi" variant="outlined"
                                    slotProps={{ htmlInput: { readOnly: true } }}
                                    value={examNew?.name || "Chưa mở đợt đăng ký mới"}
                                />
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <TextField
                                    fullWidth label="Ngày thi" variant="outlined" type="date"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    value={examNew?.examDay ? formatDate(examNew?.examDay, "yyyy-mm-dd") : ""}
                                />

                            </Grid>
                            <Grid size={12}>
                                <FormControlLabel
                                    control={<Checkbox onChange={() => {
                                        setIsDeferred(!isDeferred);
                                        handleChangeInfo({ target: { name: "prevExamDay", value: "" } });
                                        handleChangeInfo({ target: { name: "deferredSubject", value: "" } });
                                        handleChangeInfo({ target: { name: "resitSubject", value: "" } });
                                        setHeplText((prev) => ({
                                            ...prev,
                                            errorPrevExamDay: "",
                                            errorDeferredSubject: "",
                                            errorResitSubject: "",
                                        }))
                                    }} />}
                                    label={
                                        <Typography>Bảo lưu
                                            <span style={{ color: "red" }}> (Không quá 3 tháng từ lần thi trước)</span>
                                        </Typography>
                                    } />
                            </Grid>
                            {isDeferred && (
                                <>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <TextField
                                            label={
                                                <span>Ngày thi lần trước <span style={{ color: "red" }}>*</span></span>
                                            }
                                            variant="outlined"
                                            fullWidth
                                            type="date"
                                            name='prevExamDay'
                                            value={inforStudentRegis.prevExamDay || ""}
                                            onChange={handleChangeInfo}
                                            slotProps={{ inputLabel: { shrink: true } }}
                                        />
                                        {heplText.errorPrevExamDay && (
                                            <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                                {heplText.errorPrevExamDay}
                                            </Box>
                                        )}
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <FormControl fullWidth >
                                            <InputLabel id="Deferred">

                                                <span>Môn bảo lưu <span style={{ color: "red" }}>*</span></span>

                                            </InputLabel>
                                            <Select
                                                labelId="Deferred"
                                                label="Môn bảo lưu *"
                                                name="deferredSubject"
                                                value={inforStudentRegis.deferredSubject}
                                                onChange={(e) => {
                                                    handleChangeInfo(e);
                                                    handleChangeInfo({
                                                        target:
                                                        {
                                                            name: "resitSubject",
                                                            value: subject.filter(s => s !== e.target.value)[0]
                                                        }
                                                    });
                                                }}

                                            >
                                                {subject.map((item, index) =>
                                                    <MenuItem key={index} value={item}>{item}</MenuItem>
                                                )}

                                            </Select>
                                            {heplText.errorDeferredSubject && (
                                                <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                                    {heplText.errorDeferredSubject}
                                                </Box>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <FormControl fullWidth >
                                            <InputLabel id="Resit">
                                                <span>Môn thi lại <span style={{ color: "red" }}>*</span></span>
                                            </InputLabel>
                                            <Select
                                                labelId="Resit"
                                                label="Môn thi lại *"
                                                name="resitSubject"
                                                value={inforStudentRegis.resitSubject}
                                                onChange={(e) => {
                                                    handleChangeInfo(e);
                                                    handleChangeInfo({
                                                        target:
                                                        {
                                                            name: "deferredSubject",
                                                            value: subject.filter(s => s !== e.target.value)[0]
                                                        }
                                                    });
                                                }}

                                            >
                                                {subject.map((item, index) =>
                                                    <MenuItem key={index} value={item}>{item}</MenuItem>
                                                )}

                                            </Select>
                                            {heplText.errorResitSubject && (
                                                <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                                    {heplText.errorResitSubject}
                                                </Box>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </>
                            )}
                            <Grid size={12}>

                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Button
                                    component="label"
                                    role={undefined}
                                    variant="contained"
                                    fullWidth
                                    tabIndex={-1}
                                    startIcon={<CloudUpload />}
                                >
                                    Ảnh thẻ của bản thân
                                    <input
                                        type="file"
                                        hidden
                                        name='avatarFile'
                                        accept="image/*"
                                        onChange={handleChangeInfo}
                                    />
                                </Button>
                                {heplText.errorAvatarFile && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorAvatarFile}
                                    </Box>
                                )}
                                {inforStudentRegis.avatar ? (
                                    <Box sx={{ textAlign: "center", mt: 4 }}>
                                        <img
                                            src={inforStudentRegis.avatar}
                                            style={{ height: 200, maxWidth: "100%", objectFit: "cover" }}
                                            alt="Avatar"
                                        />
                                    </Box>
                                ) : null}

                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Button
                                    component="label"
                                    role={undefined}
                                    variant="contained"
                                    fullWidth
                                    tabIndex={-1}
                                    startIcon={<CloudUpload />}
                                >
                                    Ảnh chuyển khoản lệ phí thi
                                    <input
                                        type="file" hidden accept="image/*" name='imageBankingFile'
                                        onChange={handleChangeInfo}
                                    />
                                </Button>
                                {heplText.errorImageBankingFile && (
                                    <Box color="red" sx={{ mt: 0.5, fontSize: 14, fontWeight: 400 }}>
                                        {heplText.errorImageBankingFile}
                                    </Box>
                                )}
                                {inforStudentRegis.imageBanking ? (
                                    <Box sx={{ textAlign: "center", mt: 4 }}>
                                        <img
                                            src={inforStudentRegis.imageBanking}
                                            style={{ height: 200, maxWidth: "100%", objectFit: "cover" }}
                                            alt="ImageBanking"
                                        />
                                    </Box>
                                ) : null}
                            </Grid>
                            <Grid size={12} sx={{ textAlign: "center", mt: 5 }}>
                                <Button variant="contained" size="large"
                                    startIcon={<PersonAdd />}
                                    loading={isLoading}
                                    onClick={handleRegis}
                                    disabled={examNew?.id ? false : true}
                                    sx={{ width: { md: "40%", xs: "100%" } }}
                                >
                                    Đăng ký
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ maxWidth: 'lg', marginInline: 'auto', marginBlock: 6, p: 2 }}>
                <Box>
                    <Typography variant='h5' sx={{ fontWeight: "bold", color: "var(--primary)", textAlign: 'center', mb: 4 }}>
                        THÔNG BÁO VỀ VIỆC TỔ CHỨC THI TẠI FLIC
                    </Typography>
                    <Typography sx={{ textAlign: 'center', mb: 4, color: "var(--primary)" }}>
                        Tại đây bạn có thể xem tất cả thông báo liên quan đến hoạt động thi
                        Chứng chỉ Ứng dụng công nghệ thông tin Cơ bản tại DThU
                    </Typography>
                </Box>
                <Box>
                    <Grid container spacing={2}>
                        {listArticle.map((article, index) => (
                            <Grid key={index} size={{ md: 4, sm: 6, xs: 12 }}>
                                <Card
                                    variant="outlined"
                                    sx={{
                                        borderRadius: 2,
                                        overflow: "hidden",
                                        height: 450,
                                        transition: "box-shadow 0.5s",
                                        "&:hover": {
                                            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                                        }
                                    }}>
                                    <CardHeader
                                        avatar={<Avatar src={logo} aria-label="recipe" />}
                                        title={
                                            <Typography sx={{ fontWeight: 'bold', color: 'var(--primary)' }}>
                                                Trung tâm ngoại ngữ và tin học
                                            </Typography>
                                        }
                                        subheader={
                                            <Box sx={{ display: 'flex', columnGap: 2, justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                                <Typography variant="body2">
                                                    Ngày đăng: {formatDate(article.createdAt)}
                                                </Typography>
                                                <Typography variant="body2">
                                                    Lượt xem: {article.view}
                                                </Typography>
                                            </Box>
                                        }
                                    />
                                    <CardMedia
                                        sx={{ height: 240 }}
                                        image={process.env.REACT_APP_API_BASE_URL + article.image}
                                        alt={article.name} />
                                    <CardContent>
                                        <Link
                                            to={`/article-detail/${article.id}`}
                                            style={{ textDecoration: "none", color: "var(--primary)" }}
                                            className='link-blue'
                                            onClick={() => window.scrollTo({ top: 0 })}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 'bold',
                                                    fontSize: 20,
                                                    textAlign: 'center',
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                    WebkitLineClamp: 2,
                                                    overflow: 'hidden',
                                                }}>
                                                {article.name}
                                            </Typography>
                                        </Link>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
                <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Link to="/exam-notice">
                        <Button variant="contained"> Xem thêm</Button>
                    </Link>
                </Box>
            </Box>

            <Box sx={{ maxWidth: 'lg', marginInline: 'auto', marginBlock: 8, p: 2 }}>
                <Typography variant='h5' sx={{ fontWeight: "bold", color: "var(--primary)", textAlign: 'center', mb: 14 }}>
                    CHỨC NĂNG HỖ TRỢ TẠI FLIC
                </Typography>
                <Box>
                    <Grid container columnSpacing={4} rowSpacing={10}>
                        {supportFeature.map((feature, index) => (
                            <Grid key={index} size={{ md: 4, sm: 6, xs: 12 }}>
                                <Box
                                    sx={{
                                        boxShadow: "0 4px 10px 2px rgba(0,0,0,0.1)", p: 4, borderRadius: 2, minHeight: 200,
                                        position: "relative",
                                        transition: "box-shadow 0.5s",
                                        "&:hover": {
                                            boxShadow: "0px 4px 20px 5px rgba(0, 0, 0, 0.2)",
                                        }
                                    }}>
                                    <Box
                                        sx={{
                                            color: "var(--white)", backgroundColor: "var(--primary)",
                                            display: "flex", justifyContent: "center", alignItems: "center",
                                            borderRadius: "50%", width: 80, height: 80, marginInline: "auto", mb: 2,
                                            position: "absolute", top: -40, left: 0, right: 0
                                        }}>
                                        {feature.icon}
                                    </Box>
                                    <Link
                                        to={feature.url}
                                        target={feature.target}
                                        style={{ textDecoration: 'none', color: 'var(--primary)' }}
                                        onClick={() => window.scrollTo({ top: 0 })}
                                        className='link-blue'
                                    >
                                        <Typography variant='h5'
                                            sx={{ fontWeight: "bold", textAlign: 'center', mt: 4, mb: 4 }}>
                                            {feature.title}
                                        </Typography>
                                    </Link>

                                    <Typography sx={{ textAlign: "justify" }}>{feature.content}</Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>

            <Box sx={{ backgroundColor: "var(--primary)", color: "var(--white)", minHeight: 300, mb: 12, mt: 8, p: 2 }}>
                <Box sx={{ mt: 6 }}>
                    <Typography variant='h5' sx={{ fontWeight: "bold", color: "var(--white)", textAlign: 'center', mb: 4 }}>
                        VIÊN CHỨC HỖ TRỢ
                    </Typography>
                    <Typography sx={{ textAlign: 'center', color: "var(--white)" }}>
                        Nếu bạn có vấn đề thắc mắc liên quan đến kỳ thi Đánh giá năng lực tại DThU, hãy liên hệ với chúng tôi, những viên chức sau sẽ hỗ trợ bạn.
                    </Typography>
                </Box>
                <Box className="slider-container" sx={{ maxWidth: 'lg', marginInline: 'auto', marginBlock: 2, p: 2 }}>
                    <Swiper
                        centeredSlides={true}
                        loop={true}
                        pagination={{ clickable: true, }}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                                spaceBetween: 30,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 30,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        }}

                        modules={[Autoplay, Pagination]}
                        className="mySwiper"
                        style={{
                            "--swiper-pagination-color": "#FFFFFF", "--swiper-pagination-bottom": "0", paddingTop: 60, paddingBottom: 40
                        }}
                    >
                        {teacherSupport.map((teacher, index) => (
                            <SwiperSlide key={index} >
                                <Box
                                    sx={{
                                        backgroundColor: "var(--white)", p: 4, borderRadius: 2, color: "var(--primary)",
                                        position: "relative", minHeight: 200, userSelect: "none"
                                    }}>
                                    <Box
                                        sx={{
                                            width: 100, height: 100, borderRadius: "50%", overflow: "hidden",
                                            position: "absolute", top: -50, left: 0, right: 0, marginInline: "auto"
                                        }}>
                                        <img src={teacher.avatar} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                    </Box>
                                    <Typography
                                        variant='h5' sx={{ textAlign: "center", fontWeight: "bold", mt: 4 }}>
                                        {teacher.name}
                                    </Typography>
                                    <Typography
                                        sx={{ textAlign: "center", mt: 1 }}>
                                        {teacher.majors}
                                    </Typography>
                                    <Typography sx={{ mt: 4, textAlign: "justify", color: "black" }}>
                                        {teacher.content}
                                    </Typography>
                                </Box>
                            </SwiperSlide>
                        ))}
                    </Swiper>


                </Box>
            </Box>
        </>
    );
}
export default Home